/***
 * 包含了所有功能路由的菜单数据
 * @prop {string} code 和认证服务对应的控制权限的code.
 * @prop {string} name 面包屑显示的名字.
 * @prop {number} permissionType 0为菜单路由（但菜单只有两级），1为功能路由.
 * @prop {string} icon 一级菜单的图标class.
 * @prop {string} route 路由名.
 * @prop {string} module 对应路由加载的文件模块位置.
 * @prop {number} sort 排序的数字，按数字从小到大排序.
 * @prop {array} children 子级.
 * @prop {boolean} isTabRoute 是否是tab类型并且子级路由需作为它的子级的路由.
 */

const  menu = [
    {
        code: "M_ViewDynamicWindow",
        name: "View Dynamic Window",
        permissionType: 1,
        icon: "",
        route: "/notificationWindow",
        module: "dynamicNotificationWindow/notificationWindow",
        sort: 0,
        children: []
    },
    {
        code: "N_WorkStation",
        name: "Work Station",
        permissionType: 0,
        icon: "m_dashboard",
        route: "",
        module: "",
        sort: 1,
        children: [
            {
                code: "M_IncidentDashboard",
                name: "Incident Dashboard",
                permissionType: 0,
                icon: "",
                route: "/incidentDashboard",
                module: "dashboard/incidentDashboard",
                sort: 1,
                children: [
                  {
                    code: "M_TileMapManagement",
                    name: "Tile Map Management",
                    permissionType: 1,
                    icon: "",
                    route: "/addTileMapMana",
                    module: "dashboard/addTileMap/addTileMap",
                    sort: 1,
                    children: []
                  },
                  {
                    code: "M_FunctionalTileManagement",
                    name: "Functional Tile Management",
                    permissionType: 1,
                    icon: "",
                    route: "/funcTileManagement",
                    module: "dashboard/funcTileManagement",
                    sort: 2,
                    children: []
                  },
                  {
                    code: "M_IncidentDashboard",
                    name: "Incident Alarm List",
                    permissionType: 1,
                    icon: "",
                    route: "/viewAvigilon",
                    module: "dashboard/viewAvigilon",
                    sort: 3,
                    children: []
                  }
                ]
            },
            {
                code: "M_CarParkDashboard",
                name: "Car Park Dashboard",
                permissionType: 0,
                icon: "",
                route: "/carParkDashboard",
                module: "dashboard/carParkDashboard",
                sort: 1,
                children: [
                    {
                        code: "M_ManageCarParkMonitoringArea",
                        name: "Manage Car Park Monitoring Area",
                        permissionType: 1,
                        icon: "",
                        route: "/carParkMonitoringArea",
                        module: "dashboard/carParkMonitoringArea",
                        sort: 1,
                        children: []
                    }
                ]
            },
            {
                code: "M_AlarmMap",
                name: "Alarm Map",
                permissionType: 0,
                icon: "",
                route: "/alarmMap",
                module: "dashboard/alarmMap",
                sort: 1,
                children: []
            },
            {
                codes: ['M_FaceTracking','M_ViewFaceTracking'],
                name: "Track and Trace",
                permissionType: 0,
                icon: "",
                route: "/faceTracking",
                module: "dashboard/faceTracking",
                sort: 2,
                children: [
                    {
                        code: "M_ViewFaceTracking",
                        name: "Generate Track and Trace Report",
                        permissionType: 1,
                        icon: "",
                        route: "/faceTrackingReport",
                        module: "dashboard/faceTrackingGenerate",
                        sort: 6,
                        children: []
                    }
                ]
            },
            {
                codes: ['M_StatisticalChart','M_ManageMonitoringArea'],
                name: "Statistical Chart",
                permissionType: 0,
                icon: "",
                route: "/statisticalChart",
                module: "dashboard/statisticalChart",
                sort: 3,
                children: [
                    {
                        code: "M_ManageMonitoringArea",
                        name: "Manage Monitoring Area",
                        permissionType: 1,
                        icon: "",
                        route: "/monitoringArea",
                        module: "dashboard/monitoringArea",
                        sort: 1,
                        children: []
                    },
                    // {
                    //     code: "M_ManageCarParkMonitoringArea",
                    //     name: "Manage Car Park Monitoring Area",
                    //     permissionType: 1,
                    //     icon: "",
                    //     route: "/carParkMonitoringArea",
                    //     module: "dashboard/carParkMonitoringArea",
                    //     sort: 2,
                    //     children: []
                    // }
                ]
            },
            {   
                isTabRoute: true,
                codes: ['N_WorkStationWatchList','M_WatchList','M_OccupancyMonitoring','M_Overstayer','M_OverstayVehicle','M_CurrentVehicle'],
                name: "Watch List",
                permissionType: 0,
                icon: "",
                route: "/watchList",
                module: "dashboard/watchList",
                sort: 4,
                children: [
                    {
                        code: "M_WatchList",
                        name: "Watch List",
                        permissionType: 0,
                        icon: "",
                        route: "/watchListTable",
                        module: "dashboard/watchListTab/watchList",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_OccupancyMonitoring",
                        name: "Occupancy Monitoring",
                        permissionType: 0,
                        icon: "",
                        route: "/occupancyMonitoring",
                        module: "dashboard/watchListTab/occupancyMonitoring",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_Overstayer",
                        name: "Overstayer",
                        permissionType: 0,
                        icon: "",
                        route: "/overstayer",
                        module: "dashboard/watchListTab/overstayer",
                        sort: 3,
                        children: []
                    },
                    {
                        code: "M_OverstayVehicle",
                        name: "Overstay Vehicle",
                        permissionType: 0,
                        icon: "",
                        route: "/overstayVehicle",
                        module: "dashboard/watchListTab/overstayVehicle",
                        sort: 5,
                        children: []
                    },
                    {
                        code: "M_CurrentVehicle",
                        name: "Current Vehicle",
                        permissionType: 0,
                        icon: "",
                        route: "/currentVehicle",
                        module: "dashboard/watchListTab/currentVehicle",
                        sort: 5,
                        children: []
                    },
                    {
                        code: "M_ThermalData",
                        name: "Thermal Data",
                        permissionType: 0,
                        icon: "",
                        route: "/thermalData",
                        module: "dashboard/watchListTab/thermalData",
                        sort: 6,
                        children: []
                    }
                ]
            },
            {
                code: "M_ArmingDashboard",
                name: "Arming Dashboard",
                permissionType: 0,
                icon: "",
                route: "/armingDashboard",
                module: "dashboard/armingDashboard",
                sort: 6,
                children: []
            }
        ]
    },
    {
        code: "N_User",
        name: "User",
        permissionType: 0,
        icon: "m_user",
        route: null,
        module: null,
        // sort: 2,
        sort:2,
        children: [
            {
                codes: ['M_UserStaff','M_AddStaff','M_EditStaff'],
                name: "Staff",
                permissionType: 0,
                icon: null,
                route: "/staffList",
                module: "staffManagement/staffList",
                sort: 1,
                children: [
                    {
                        code: "M_AddStaff",
                        name: "Create Staff",
                        permissionType: 1,
                        icon: null,
                        route: "/addStaff",
                        module: "staffManagement/addStaff",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_EditStaff",
                        name: "Edit Staff Profile",
                        permissionType: 1,
                        icon: null,
                        route: "/editStaff",
                        module: "staffManagement/editStaff",
                        sort: 2,
                        children: []
                    },
                    {
                        codes: ['M_ViewStaffGeneralAccessReport','M_ViewIncidentReport'],
                        name: "User Report",
                        permissionType: 1,
                        noRelevance:true,
                        icon: "",
                        route: "/staffUserRecord",
                        module: "staffManagement/userRecord",
                        sort: 8,
                        children: []
                    },
                ]
            },
            {
                codes: ['M_UserVisitor','M_AddVisitor','M_EditVisitor'],
                name: "Visitor",
                permissionType: 0,
                icon: null,
                route: "/visitorList",
                module: "visitorManagement/visitorList",
                sort: 2,
                children: [
                    {
                        code: "M_AddVisitor",
                        name: "Create Visitor",
                        permissionType: 1,
                        icon: null,
                        route: "/addVisitor",
                        module: "visitorManagement/addVisitor",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_EditVisitor",
                        name: "Edit Visitor Profile",
                        permissionType: 1,
                        icon: null,
                        route: "/editVisitor",
                        module: "visitorManagement/editVisitor",
                        sort: 2,
                        children: []
                    },
                    {
                        codes: ['M_ViewVisitorGeneralAccessReport','M_ViewIncidentReport'],
                        name: "User Report",
                        permissionType: 1,
                        icon: "",
                        noRelevance:true,
                        route: "/visitorUserRecord",
                        module: "staffManagement/userRecord",
                        sort: 8,
                        children: []
                    }
                ]
            },
            {
                codes: ['M_UserVendor','M_AddVendor','M_EditVendor'],
                name: "Vendor",
                permissionType: 0,
                icon: null,
                route: "/vendorList",
                module: "vendorManagement/vendorList",
                sort: 3,
                children: [
                    {
                        code: "M_AddVendor",
                        name: "Create Vendor",
                        permissionType: 1,
                        icon: null,
                        route: "/addVendor",
                        module: "vendorManagement/addVendor",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_EditVendor",
                        name: "Edit Vendor Profile",
                        permissionType: 1,
                        icon: null,
                        route: "/editVendor",
                        module: "vendorManagement/editVendor",
                        sort: 2,
                        children: []
                    },
                    {
                        codes: ['M_ViewVendorGeneralAccessReport','M_ViewIncidentReport'],
                        name: "User Report",
                        permissionType: 1,
                        icon: "",
                        noRelevance:true,
                        route: "/vendorUserRecord",
                        module: "staffManagement/userRecord",
                        sort: 9,
                        children: []
                    }
                ]
            },
            {
                codes: ['M_UserTenant','M_AddTenant','M_EditTenant'],
                name: "Tenant",
                permissionType: 0,
                icon: null,
                route: "/tenantList",
                module: "tenantManagement/tenantList",
                sort: 4,
                children: [
                    {
                        code: "M_AddTenant",
                        name: "Create Tenant",
                        permissionType: 1,
                        icon: null,
                        route: "/addTenant",
                        module: "tenantManagement/addTenant",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_EditTenant",
                        name: "Edit Tenant Profile",
                        permissionType: 1,
                        icon: null,
                        route: "/editTenant",
                        module: "tenantManagement/editTenant",
                        sort: 2,
                        children: []
                    },
                    {
                        codes: ['M_ViewTenantGeneralAccessReport','M_ViewIncidentReport'],
                        name: "User Report",
                        permissionType: 1,
                        icon: "",
                        noRelevance:true,
                        route: "/tenantUserRecord",
                        module: "staffManagement/userRecord",
                        sort: 9,
                        children: []
                    }
                ]
            }
        ]
    },
    {
        code: "N_Vehicle",
        name: "Vehicle",
        permissionType: 0,
        icon: "m_vehicle",
        route: "", 
        module: "",
        // sort: 2,
        sort: 3,
        children: [
            {
                codes: ['M_VehicleManagement','M_AddVehicle','M_EditVehicle'],
                name: "Vehicle Management",
                permissionType: 0,
                icon: "",
                route: "/vehicleList",
                module: "vehicleManagement/vehicleList",
                sort: 1,
                children: [
                    {
                        code: "M_AddVehicle", 
                        name: "Create Vehicle",
                        permissionType: 1,
                        icon: "",
                        route: "/addVehicle",
                        module: "vehicleManagement/addVehicle",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_EditVehicle",
                        name: "Edit Vehicle",
                        permissionType: 1,
                        icon: "",
                        route: "/editVehicle",
                        module: "vehicleManagement/editVehicle",
                        sort: 2,
                        children: []
                    },
                    {
                        name: "View Vehicle Report",
                        codes: ['M_VehicleAccess','M_ParkingCost','M_IncidentReport'],
                        noRelevance:true,
                        permissionType: 1,
                        icon: "",
                        route: "/vehicleReports",
                        module: "vehicleManagement/vehicleReports",
                        sort: 5,
                        children: []
                    },
                ]
            },
            {
                codes: ['M_BillingPolicy','M_AddBillingPolicy','M_EditBillingPolicy'],
                name: "Billing Policy",
                permissionType: 0,
                icon: "",
                route: "/billingPolicy",
                module: "vehicleManagement/billingPolicy",
                sort: 2,
                children: [
                    {
                        code: "M_AddBillingPolicy",
                        name: "Create Billing Policy",
                        permissionType: 1,
                        icon: "",
                        route: "/billingPolicyInfo",
                        module: "vehicleManagement/billingPolicyInfo",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_EditBillingPolicy",
                        name: "Edit Billing Policy",
                        permissionType: 1,
                        icon: "",
                        route: "/billingPolicyInfo",
                        module: "vehicleManagement/billingPolicyInfo",
                        sort: 3,
                        children: []
                    },
                ]
            }
        ]
    },
    {
        code: "N_AccessControl",
        name: "Access Control",
        permissionType: 0,
        icon: "m_access_control",
        route: null,
        module: null,
        sort: 4,
        children: [
            {
                codes: ['M_AccessZone','M_AddAccessZone','M_EditAccessZone','M_AreaManagement'],
                name: "Access Zone",
                permissionType: 0,
                icon: null,
                route: "/pointList",
                module: "accessZoneManagement/pointList",
                sort: 0,
                children: [
                    {
                        code: "M_AddAccessZone",
                        name: "Create Access Zone",
                        permissionType: 1,
                        icon: null,
                        route: "/addPointInfo",
                        module: "accessZoneManagement/addPointInfo",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_EditAccessZone",
                        name: "Edit Access Zone",
                        permissionType: 1,
                        icon: null,
                        route: "/editPointInfo",
                        module: "accessZoneManagement/editPointInfo",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_AreaManagement",
                        name: "Area Management",
                        permissionType: 0,
                        icon: null,
                        route: "/areaManagement",
                        module: "accessControlManagement/areaManagement",
                        sort: 4,
                        children: []
                    },
                ]
            },
            {
                code: "M_Device",
                name: "Device",
                permissionType: 0,
                icon: null,
                route: "/deviceList",
                module: "deviceManagement/deviceList",
                sort: 2,
                children: []
            },
            {
                codes: ['M_AccessCode','M_EditAccessCode'],
                name: "Access Code",
                permissionType: 0,
                icon: null,
                route: "/accessCodeList",
                module: "accessControlManagement/accessCodeList",
                sort: 3,
                children: [
                    {
                        code: "M_EditAccessCode",
                        name: "Edit Access Zone To Access Code",
                        permissionType: 0,
                        icon: "",
                        route: "/editPointToAC",
                        module: "accessControlManagement/editPointToAC",
                        sort: 4,
                        children: []
                    },
                ]
            },
            {
                code: "M_Map",
                name: "Map",
                permissionType: 0,
                icon: null,
                route: "/mapList",
                module: "accessControlManagement/mapList",
                sort: 4,
                children: []
            },
            {
                isTabRoute: true,
                codes: ['N_AccessControlAdvancedFeatures','M_DoorAccessControl','M_2FASetting','M_MultiFactorsAuthentication','M_AntiPassback','M_OccupancyLimit','M_VehicleAntiPassback'],
                name: "Advanced Features",
                permissionType: 0,
                icon: "",
                route: "/advancedFeatures",
                module: "advancedFeatures/advancedFeatures",
                sort: 5,
                children: [
                    {
                        code: "M_DoorAccessControl",
                        name: "Door Access Control",
                        permissionType: 0,
                        icon: "",
                        route: "/doorAccessControl",
                        module: "advancedFeatures/doorAccessControl",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_2FASetting",
                        name: "2FA Setting",
                        permissionType: 0,
                        icon: "",
                        route: "/twoFASetting",
                        module: "advancedFeatures/twoFASetting",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_MultiFactorsAuthentication",
                        name: "Multi Factors Authentication",
                        permissionType: 0,
                        icon: "",
                        route: "/multiFactorsAuthentication",
                        module: "advancedFeatures/multiFactorsAuthentication",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_AntiPassback",
                        name: "Anti Passback",
                        permissionType: 0,
                        icon: "",
                        route: "/antiPassBack",
                        module: "advancedFeatures/antiPassback",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_OccupancyLimit",
                        name: "Occupancy Limit",
                        permissionType: 0,
                        icon: "",
                        route: "/occupancyLimit",
                        module: "advancedFeatures/occupancyLimit",
                        sort: 3,
                        children: []
                    },
                    {
                        code: "M_VehicleAntiPassback",
                        name: "Vehicle Anti-passback",
                        permissionType: 0,
                        icon: "",
                        route: "/vehicleAntiPassback",
                        module: "advancedFeatures/vehicleAntiPassback",
                        sort: 5,
                        children: []
                    }
                ]
            },
            {
                code: "M_ArmingManagement",
                name: "Arming Management",
                permissionType: 0,
                icon: "",
                route: "/armingManagement",
                module: "accessControlManagement/armingManagement",
                sort: 6,
                children: []
            }
        ]
    },
    {
        code: "N_EventMonitoring",
        name: "Event Monitoring",
        permissionType: 0,
        icon: "m_eventMonitoring",
        route: null,
        module: null,
        // sort: 6,
        sort: 5,
        children:[     
            {
                code: "M_ViewEventMonitoring",
                name: "Event Monitoring",
                permissionType: 0,
                icon: null,
                route: "/eventMonitoring",
                module: "eventMonitoring/eventMonitoringSetting/eventMonitoringView",
                sort: 0,
                children: [],
            },
            {
                code: "M_VirtualPatrol",
                name: "Virtual Patrol",
                permissionType: 0,
                icon: null,
                route: "/virtualPatrol",
                module: "eventMonitoring/virtualPatrol/virtualPortalWork",
                sort: 1,
                children: [],
            },
            {
                isTabRoute: true,
                codes: ['N_EventMonitoringVirtualPatrolSetting','M_ViewPatrolPoint','M_ViewRouteConfiguration'],
                name: "Virtual Patrol Setting",
                permissionType: 0,
                icon: null,
                route: "/virtualPatrolSetting",
                module: "eventMonitoring/virtualPatrolSetting/virtualPortalSetting",
                sort: 2,
                children: [
                    {
                        codes: ['M_ViewPatrolPoint','M_AddPatrolPoint'],
                        name: "Patrol Point Setting",
                        permissionType: 0,
                        icon: null,
                        route: "/patrolPointSetting",
                        module: "eventMonitoring/virtualPatrolSetting/virtualPortalList",
                        sort: 0,
                        children: [
                            {
                                name: "Create Virtual Point",
                                route: "/addVirtualPortal",
                                code: "M_AddPatrolPoint",
                                permissionType: 1,
                                module: "eventMonitoring/virtualPatrolSetting/addVirtualPortal",
                                sort: 2,
                                children: []
                            },
                        ]
                    },
                    {
                        code: "M_ViewRouteConfiguration",
                        name: "Route Configuration",
                        permissionType: 0,
                        icon: null,
                        route: "/taskConfiguration",
                        module: "eventMonitoring/virtualPatrolSetting/taskConfiguration",
                        sort: 1,
                        children: []
                    },
                ],
            },
            {
                code: "M_VideoDownloadCenter",
                name: "Video Download Center",
                permissionType: 0,
                icon: null,
                route: "/ideoDownloadCenter",
                module: "eventMonitoring/videoDownloadCenter/videoDownloadView",
                sort: 3,
                children: [],
            }
        ]
    },
    {
        code: "N_Incident",
        name: "Incident",
        permissionType: 0,
        icon: "m_incident",
        route: "",
        module: "",
        // sort: 4,
        sort: 6,
        children: [
            {
                isTabRoute: true,
                codes: ['N_IncidentIncidentManagement','M_IncidentAlarm','M_Notification','M_Task','M_CustomisedIncident'],
                name: "Incident Management",
                permissionType: 0,
                icon: null,
                route: "/incidentManagement",
                module: "incidentManagement/incidentManagement",
                sort: 1,
                children: [
                    {
                        codes: ['M_IncidentAlarm','M_AddIncidentAlarm','M_EditIncidentAlarm', 'M_ESOPTemplateManagement','M_AddESOPTemplate','M_EditESOPTemplate'],
                        name: "Incident Alarm",
                        permissionType: 0,
                        route: "/incidentAlarm",
                        module: "incidentManagement/incidentAlarm",
                        sort: 7,
                        children: [
                            {
                                code: "M_AddIncidentAlarm",
                                name: "Create Incident Alarm",
                                permissionType: 1,
                                route: "/addIncidentAlarm",
                                module: "incidentManagement/addIncident",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditIncidentAlarm",
                                name: "Edit Incident Alarm",
                                permissionType: 1,
                                route: "/editIncidentAlarm",
                                module: "incidentManagement/addIncident",
                                sort: 2,
                                children: []
                            },{
                                code: "M_ESOPTemplateManagement",
                                name: "ESOP Template Management",
                                permissionType: 1,
                                route: "/esopTemplate",
                                module: "incidentManagement/esopTemplate",
                                sort: 3,
                                children: [
                                    {
                                        code: "M_AddESOPTemplate",
                                        name: "Create ESOP Template",
                                        permissionType: 1,
                                        route: "/addESOPTemplate",
                                        module: "incidentManagement/esopTemplateInfo",
                                        sort: 1,
                                        children: []
                                    },
                                    {
                                        code: "M_EditESOPTemplate",
                                        name: "Edit ESOP Template",
                                        permissionType: 1,
                                        route: "/editESOPTemplate",
                                        module: "incidentManagement/esopTemplateInfo",
                                        sort: 2,
                                        children: []
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        codes: ['M_Notification','M_AddNotification','M_EditNotification'],
                        name: "System Notification",
                        permissionType: 0,
                        icon: "",
                        route: "/systemNotification",
                        module: "incidentManagement/systemNotification",
                        sort: 8,
                        children: [
                            {
                                code: "M_AddNotification",
                                name: " Create System Notification",
                                permissionType: 1,
                                route: "/addSystemNotification",
                                module: "incidentManagement/addIncident",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditNotification",
                                name: "Edit System Notification",
                                permissionType: 1,
                                route: "/editSystemNotification",
                                module: "incidentManagement/addIncident",
                                sort: 2,
                                children: []
                            }
                        ]
                    },
                    {
                        codes: ['M_Task','M_AddTask','M_EditTask'],
                        name: "Task",
                        permissionType: 0,
                        icon: "",
                        route: "/taskList",
                        module: "incidentManagement/taskList",
                        sort: 8,
                        children: [
                            {
                                code: "M_AddTask",
                                name: " Create Task",
                                permissionType: 1,
                                route: "/addTask",
                                module: "incidentManagement/addIncident",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditTask",
                                name: "Edit Task",
                                permissionType: 1,
                                route: "/editTask",
                                module: "incidentManagement/addIncident",
                                sort: 2,
                                children: []
                            }
                        ]
                    },
                    {
                        codes: ['M_CustomisedIncident','M_AddCustomisedIncident','M_EditCustomisedIncident'],
                        name: "Customised Incident",
                        permissionType: 0,
                        icon: "",
                        route: "/customisedIncidentList",
                        module: "incidentManagement/customisedIncident/customisedIncidentList",
                        sort: 7,
                        children: [
                            {
                                code: "M_AddCustomisedIncident",
                                name: "Create Customised Incident",
                                permissionType: 1,
                                icon: "",
                                route: "/addCustomisedIncident",
                                module: "incidentManagement/customisedIncident/addCustomisedIncident",
                                sort: 2,
                                children: []
                            },
                            {
                                code: "M_EditCustomisedIncident",
                                name: "Edit Customised Incident",
                                permissionType: 1,
                                icon: "",
                                route: "/editCustomisedIncident",
                                module: "incidentManagement/customisedIncident/editCustomisedIncident",
                                sort: 3,
                                children: []
                            },
                        ]
                    },
                ]
            },
            {
                isTabRoute: true,
                codes: ['N_IncidentMyIncident','M_MyAlarm','M_MyNotification','M_MyTask'],
                name: "My Incident",
                permissionType: 0,
                icon: "",
                route: "/myIncident",
                module: "incidentManagement/myIncident",
                sort: 2,
                children: [
                    {
                        code: "M_MyAlarm",
                        name: "My Alarm",
                        permissionType: 0,
                        route: "/myAlarm",
                        module: "incidentManagement/myAlarms",
                        sort: 1,
                        children: [
                            {
                              code: "M_MyAlarm",
                              name: "My Alarms",
                              permissionType: 1,
                              route: "/myAlarm",
                              module: "reportsManagement/myAlarm",
                              sort: 1,
                              children: []
                            },
                            {
                              code: "M_MyAlarm",
                              name: "Pending Processing",
                              permissionType: 1,
                              route: "/pendingProcessing",
                              module: "incidentManagement/pendingProcessing",
                              sort: 2,
                              children: []
                            },
                            {
                              code: "M_ProcessAlarm",
                              name: "Process",
                              permissionType: 1,
                              route: "/incidentProcess",
                              module: "incidentManagement/processHandle/processHandle",
                              sort: 3,
                            },
                            {
                              code: "M_ReportIncident",
                              name: "Report Incident",
                              permissionType: 0,
                              route: "/reportIncident",
                              module: "incidentManagement/reportIncident",
                              sort: 4,
                              children: []
                            }
                        ]
                    },
                    {
                        code: "M_MyNotification",
                        name: "My Notification",
                        permissionType: 0,
                        icon: "",
                        route: "/myNotification",
                        module: "incidentManagement/myNotification",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_MyTask",
                        name: "My Task",
                        permissionType: 0,
                        icon: "",
                        route: "/myTask",
                        module: "incidentManagement/myTask",
                        sort: 3,
                        children: []
                    }
                ]
            }
        ]
    },
    {
        code: "N_Report",
        name: "Report",
        permissionType: 0,
        icon: "m_report",
        route: null,
        module: null,
        // sort: 4,
        sort: 9,
        children: [
            {
                isTabRoute: true,
                codes: ['N_ReportGeneratedReport','M_RecurringReport','M_ManuallyGenerated'],
                name: "Generated Report",
                permissionType: 0,
                icon: null,
                route: "/generateReport",
                module: "generateReport/generateReport",
                sort: 0,
                children: [
                    {
                        code: "M_RecurringReport",
                        name: "Recurring",
                        permissionType: 0,
                        icon: "",
                        route: "/recurring",
                        module: "generateReport/recurring",
                        sort: 0,
                        children: []
                    },
                    {
                        code: "M_ManuallyGenerated",
                        name: "Manually Generated",
                        permissionType: 0,
                        icon: "",
                        route: "/manuallyGenerated",
                        module: "generateReport/manuallyGenerated",
                        sort: 1,
                        children: []
                    },
                ]
            },
            {
                code: "M_Recurring",
                name: "Recurring Report",
                permissionType: 0,
                icon: null,
                route: "/recurringReport",
                module: "recurringReport/recurringReport",
                sort: 1,
                children: []
            },
            {
                isTabRoute: true,
                codes: ['N_ReportUserReport','M_GeneralAccess','M_DCSAccess','M_UserRegistration','M_AccessRight','M_TrafficReport','M_FaceDetection','M_QRCodeVerification','M_CardUsage','M_UserProfile','M_FaceVerification','M_AttendanceReport','M_UserLogin','M_PalmVein'],
                name: "User Report",
                permissionType: 0,
                icon: null,
                route: "/visitorReport",
                module: "reportsManagement/visitorReport",
                sort: 2,
                children: [
                    {
                        code: "M_QRAccess",
                        name: "QR Access",
                        permissionType: 1,
                        icon: null,
                        route: "/qrAccess",
                        module: "reportsManagement/qrAccess",
                        sort: 0,
                        children: []
                    },
                    {
                        code: "M_GeneralAccess",
                        name: "General Access",
                        permissionType: 1,
                        icon: null,
                        route: "/generalAccessReport",
                        module: "reportsManagement/generalAccess",
                        sort: 7,
                        children: []
                    },
                    {
                        code: "M_Reg_Auth_Report",
                        name: "Reg & Auth Report",
                        permissionType: 1,
                        icon: null,
                        route: "/RegAuthReport",
                        module: "reportsManagement/RegAuthReport",
                        sort: 7,
                        children: []
                    },
                    {
                        code: "M_DCSAccess",
                        name: "DCS Access",
                        permissionType: 1,
                        icon: "",
                        route: "/dcsAccess",
                        module: "reportsManagement/dcsAccess",
                        sort: 8,
                        children: []
                    },
                    {
                        code: "M_UserRegistration",
                        name: "User Registration",
                        permissionType: 0,
                        icon: null,
                        route: "/registrationReport",
                        module: "reportsManagement/registrationReport",
                        sort: 8,
                        children: []
                    },
                    {
                        code: "M_FingerprintVerification",
                        name: "Fingerprint Verification",
                        permissionType: 1,
                        icon: "",
                        route: "/fingerprintVerification",
                        module: "reportsManagement/fingerprintVerification",
                        sort: 9,
                        children: []
                    },
                    {
                        code: "M_AccessRight",
                        name: "Access Right",
                        permissionType: 0,
                        icon: null,
                        route: "/accessRightReport",
                        module: "reportsManagement/accessRightReport",
                        sort: 9,
                        children: []
                    },
                    {
                        code: "M_TrafficReport",
                        name: "Traffic Report",
                        permissionType: 0,
                        icon: null,
                        route: "/occupancyReport",
                        module: "reportsManagement/occupancyReport",
                        sort: 10,
                        children: []
                    },
                    {
                        code: "M_FaceDetection",
                        name: "Face Detection",
                        permissionType: 0,
                        icon: null,
                        route: "/faceDetectionReport",
                        module: "reportsManagement/faceDetection",
                        sort: 11,
                        children: []
                    },
                    {
                        code: "M_QRCodeVerification",
                        name: "QR Code Verification",
                        permissionType: 0,
                        icon: "",
                        route: "/qrCodeVerification",
                        module: "reportsManagement/qrCodeVerification",
                        sort: 12,
                        children: []
                    },
                    {
                        code: "M_CardUsage",
                        name: "Card Usage",
                        permissionType: 0,
                        icon: "",
                        route: "/cardUsageReport",
                        module: "reportsManagement/cardUsage",
                        sort: 12,
                        children: []
                    },
                    {
                        code: "M_UserProfile",
                        name: "User Profile",
                        permissionType: 0,
                        icon: null,
                        route: "/userProfileReport",
                        module: "reportsManagement/userProfileReport",
                        sort: 13,
                        children: []
                    },
                    {
                        code: "M_FaceVerification",
                        name: "Face Verification",
                        permissionType: 0,
                        icon: "",
                        route: "/frVerificationReport",
                        module: "reportsManagement/frVerification",
                        sort: 15,
                        children: []
                    },
                    {
                        code: "M_PalmVein",
                        name: "Palm Vein",
                        permissionType: 0,
                        icon: "",
                        route: "/PalmVeinReport",
                        module: "reportsManagement/palmVein",
                        sort: 18,
                        children: []
                    },
                    {
                        code: "M_AttendanceReport",
                        name: "Attendance",
                        permissionType: 0,
                        icon: null,
                        route: "/attendanceReport",
                        module: "reportsManagement/attendanceReport",
                        sort: 16,
                        children: []
                    },
                    {
                        code: "M_UserLogin",
                        name: "User Login",
                        permissionType: 0,
                        icon: "",
                        route: "/userLogin",
                        module: "reportsManagement/userLogin",
                        sort: 17,
                        children: []
                    },
                    // {
                    //     code: "M_ViewVirtualPatrolReport",
                    //     name: "Virtual Patrol",
                    //     permissionType: 0,
                    //     icon: "",
                    //     route: "/virtualPatrolReport",
                    //     module: "reportsManagement/virtualPatrol/virtualPatrol",
                    //     sort: 17,
                    //     children: []
                    // },
                ]
            },
            {
              code: "M_DoorActivity",
              name: "Door Activity",
              permissionType: 0,
              icon: "",
              route: "/doorActivityReport",
              module: "reportsManagement/doorActivity",
              sort: 3,
              children: []
            },
            {
                codes: ['M_IncidentReport','M_ViewIncidentReport'],
                name: "Incident Report",
                permissionType: 0,
                icon: "",
                route: "/IncidentReport",
                module: "reportsManagement/incidentReport",
                sort: 4,
                isTabRoute: true,
                children: [
                    {
                        code: "M_ViewIncidentReport",
                        name: "Incident Alarms",
                        permissionType: 1,
                        route: "/incidentAlarmReport",
                        module: "reportsManagement/incidentAlarmReport",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_ViewNotificationReport",
                        name: "System Notifications",
                        permissionType: 1,
                        icon: "",
                        route: "/systemNotificationReport",
                        module: "reportsManagement/systemNotificationReport",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_ViewTasksReport",
                        name: "Tasks",
                        permissionType: 1,
                        icon: "",
                        route: "/taskReport",
                        module: "reportsManagement/taskReport",
                        sort: 2,
                        children: []
                    }
                ]
            },
            {
                isTabRoute: true,
                codes: ['N_ReportUserActivityReport','M_FirstInAndLastOut'],
                name: "User Activity Report",
                permissionType: 0,
                icon: null,
                route: "/userActivityReport",
                module: "userActivityReport/userActivityReport",
                sort: 5,
                children: [
                    {
                        code: "M_FirstInAndLastOut",
                        name: "First In And Last Out",
                        permissionType: 0,
                        icon: "",
                        route: "/firstInAndLastOut",
                        module: "userActivityReport/firstInAndLastOut",
                        sort: 0,
                        children: []
                    }
                ]
            },
            {
                isTabRoute: true,
                codes: ['N_ReportDataChangeReport','M_UserInformation','M_SystemDeviceConfiguration','M_AccountAndRole','M_SystemSettingReport','M_Administration'],
                name: "Data Change Report",
                permissionType: 0,
                icon: "",
                route: "/dataChangeReport",
                module: "dataChangeReport/dataChangeReport",
                sort: 6,
                children: [
                    {
                        code: "M_UserInformation",
                        name: "User Information",
                        permissionType: 0,
                        icon: "",
                        route: "/userInformation",
                        module: "dataChangeReport/userInformation",
                        sort: 0,
                        children: []
                    },
                    {
                        code: "M_SystemDeviceConfiguration",
                        name: "System Device Configuration",
                        permissionType: 0,
                        icon: "",
                        route: "/systemDeviceConfiguration",
                        module: "dataChangeReport/systemDeviceConfiguration",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_AccountAndRole",
                        name: "Account And Role",
                        permissionType: 0,
                        icon: "",
                        route: "/accountAndRole",
                        module: "dataChangeReport/accountAndRole",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_SystemSettingReport",
                        name: "System Setting",
                        permissionType: 0,
                        icon: "",
                        route: "/systemSettingReport",
                        module: "dataChangeReport/systemSettingReport",
                        sort: 3,
                        children: []
                    },
                    {
                        code: "M_Administration",
                        name: "Administration",
                        permissionType: 0,
                        icon: "",
                        route: "/administration",
                        module: "dataChangeReport/administration",
                        sort: 4,
                        children: []
                    }
                ]
            },
            {
                isTabRoute: true,
                codes: ['N_ReportVehicleReport','M_VehicleAccess','M_VehicleRegistration','M_ParkingCost','M_BarrierOperation','M_VehicleProfile'],
                name: "Vehicle Report",
                permissionType: 0,
                icon: "",
                route: "/vehicleReport",
                module: "vehicleReport/vehicleReport",
                sort: 7,
                children: [
                    {
                        code: "M_VehicleAccess",
                        name: "Vehicle Access",
                        permissionType: 0,
                        icon: "",
                        route: "/vehicleAccessReport",
                        module: "vehicleReport/vehicleAccessReport",
                        sort: 0,
                        children: []
                    },
                    {
                        code: "M_VehicleRegistration",
                        name: "Vehicle Registration",
                        permissionType: 0,
                        icon: "",
                        route: "/vehicleRegistrationReport",
                        module: "vehicleReport/vehicleRegistrationReport",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_ParkingCost",
                        name: "Parking Cost",
                        permissionType: 0,
                        icon: "",
                        route: "/parkingCostReport",
                        module: "vehicleReport/parkingCostReport",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_BarrierOperation",
                        name: "Barrier Operation",
                        permissionType: 0,
                        icon: "",
                        route: "/barrierOperationReport",
                        module: "vehicleReport/barrierOperationReport",
                        sort: 3,
                        children: []
                    },
                    {
                        code: "M_VehicleProfile",
                        name: "Vehicle Profile",
                        permissionType: 0,
                        icon: "",
                        route: "/vehicleProfileReport",
                        module: "vehicleReport/vehicleProfileReport",
                        sort: 6,
                        children: []
                    },
                    {
                        code: "M_VehicleDataChangeReport",
                        name: "Data Change",
                        permissionType: 0,
                        icon: "",
                        route: "/dataChangeVehicleReport",
                        module: "vehicleReport/dataChange",
                        sort: 7,
                        children: [
                            {
                                code: "M_VehicleInformationChange",
                                name: "Vehicle Information Change",
                                permissionType: 0,
                                icon: "",
                                route: "",
                                module: "vehicleReport/vehicleInformation",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_AccessCodeChangeVehicleReport",
                                name: "Access Code Change",
                                permissionType: 0,
                                icon: "",
                                route: "",
                                module: "vehicleReport/dataChange",
                                sort: 2,
                                children: []
                            }
                        ]
                    }
                ]
            },    
            {
                code: "M_VirtualPatrolReport",
                name: "Virtual Patrol Report",
                permissionType: 0,
                icon: "",
                route: "/virtualPatrolReport",
                module: "reportsManagement/virtualPatrol/virtualPatrol",
                sort: 8,
                children: []
            },
            {
              isTabRoute: true,
              codes: ['M_AttendancesRateReport', 'M_AttendancesReport'],
              name: "Attendance Report",
              permissionType: 0,
              icon: "",
              route: "/attendanceReports",
              module: "attendanceReport/attendanceReport",
              sort: 9,
              children: [
                  {
                      code: "M_AttendancesRateReport",
                      name: "Attendance Rate Statistics",
                      permissionType: 0,
                      icon: "",
                      route: "/attendanceRateStatistics",
                      module: "attendanceReport/attendanceRateStatistics",
                      sort: 0,
                      children: []
                  },
                  {
                      code: "M_AttendancesReport",
                      name: "Attendance Record",
                      permissionType: 0,
                      icon: "",
                      route: "/attendanceRecord",
                      module: "attendanceReport/attendanceRecord",
                      sort: 1,
                      children: []
                  },
              ]
            },
        ]
    },
    {       
        code: "N_ResourceManagement",
        name: "Resource",
        permissionType: 0,
        icon: "m_resource",
        route: null,
        module: null,
        sort: 5,
        children: [
            {
                code: "M_ViewResourceManagement",
                name: "Resource Management",
                permissionType: 0,
                icon: null,
                route: "/resource",
                module: "resource/resourceList",
                sort: 0,
                children: []
            },
            {
                code: "M_ViewResourceManagement",
                name: "Resource  Management",
                permissionType: 1,
                icon: null,
                route: "/resourceMore",
                module: "resource/resourceMore",
                sort: 0,
                 children: []
            }
          
        ]
    },
    {
        code: "N_System",
        name: "System",
        permissionType: 0,
        icon: "m_system",
        route: null,
        module: null,
        // sort: 5,
        sort: 10,
        children: [
            {
                isTabRoute: true,
                codes: ['N_SystemAdministration','M_PrivilegeManagement','N_SystemAdministrationAccountManagement','M_StaffOrganization','M_CardManagement','M_ManpowerManagement','M_PrintTeplate','M_TagManagement','M_TenantOrganization','M_SingleEntryPolicy','M_AttendanceSetting','M_CostCenterManagement'],
                name: "Administration",
                permissionType: 0,
                icon: null,
                route: "/adminManagement",
                module: "adminManagement/adminManagement",
                sort: 0,
                children: [
                    {
                        codes: ['M_PrivilegeManagement','M_AddRole','M_EditRole'],
                        name: "Privilege Management",
                        permissionType: 0,
                        icon: null,
                        route: "/privilegeManagement",
                        module: "adminManagement/privilegeManagement",
                        sort: 0,
                        children: [
                            {
                                code: "M_AddRole",
                                name: "Create Role",
                                permissionType: 1,
                                icon: null,
                                route: "/addRole",
                                module: "adminManagement/addRole",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditRole",
                                name: "Edit Role",
                                permissionType: 1,
                                icon: null,
                                route: "/editRole",
                                module: "adminManagement/addRole",
                                sort: 2,
                                children: []
                            },
                        ]
                    },
                    {
                        code: "N_SystemAdministrationAccountManagement",
                        name: "Account Management",
                        permissionType: 0,
                        icon: null,
                        route: "/accountManagement",
                        module: "adminManagement/accountManagement",
                        sort: 1,
                        children: []
                    },
                    {
                        codes: ['M_StaffOrganization','M_AddOrganization','M_EditOrganization','M_EditDepartment','M_AddDepartment','M_ViewStaffCorTable','M_ViewStaffStructure'],
                        name: "Organization",
                        permissionType: 0,
                        icon: null,
                        route: "/staffOrganization",
                        module: "adminManagement/staffOrganization",
                        sort: 1,
                        children: [
                            {
                                code: "M_AddOrganization",
                                name: "Create Organization",
                                permissionType: 1,
                                icon: null,
                                route: "/addOrganization",
                                module: "adminManagement/addDepartment",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditOrganization",
                                name: "Edit Organization",
                                permissionType: 1,
                                icon: null,
                                route: "/editOrganization",
                                module: "adminManagement/editDepartment",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditDepartment",
                                name: "Edit Department",
                                permissionType: 1,
                                icon: null,
                                route: "/editDepartment",
                                module: "adminManagement/editDepartment",
                                sort: 2,
                                children: []
                            },
                            {
                                code: "M_AddDepartment",
                                name: "Create Department",
                                permissionType: 1,
                                icon: null,
                                route: "/addDepartment",
                                module: "adminManagement/addDepartment",
                                sort: 2,
                                children: []
                            },
                            {
                                code: "M_ViewStaffCorTable",
                                name: "View Correspondace Table",
                                permissionType: 1,
                                icon: null,
                                route: "/staffCorrespondence",
                                module: "adminManagement/staffCorrespondence",
                                sort: 2,
                                children: []
                            },
                            {
                                code: "M_ViewStaffStructure",
                                name: "View Structure Diagram",
                                permissionType: 1,
                                icon: null,
                                route: "/organization",
                                module: "adminManagement/organizationPreview",
                                sort: 2,
                                children: []
                            },
                        ]
                    },
                    {
                        code: "M_ModuleManagement",
                        name: "Module Management",
                        permissionType: 0,
                        icon: null,
                        route: "/moduleManagement",
                        module: "adminManagement/moduleManagement/moduleManagement",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_CardManagement",
                        name: "Card Management",
                        permissionType: 0,
                        icon: null,
                        route: "/cardManagement",
                        module: "adminManagement/cardManagement",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "N_SystemAdministrationManpowerManagement",
                        name: "Manpower Management",
                        permissionType: 0,
                        icon: "",
                        route: "/manpowerManagement",
                        module: "adminManagement/manpowerManagement/manpowerManagement",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_PrintTeplate",
                        name: "Print Template",
                        permissionType: 0,
                        icon: "",
                        route: "/cardTemplateInfo",
                        module: "adminManagement/cardTemplateInfo",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_TagManagement",
                        name: "Tag Management",
                        permissionType: 0,
                        icon: "",
                        route: "/tagManagement",
                        module: "adminManagement/tagManagement",
                        sort: 3,
                        children: []
                    },
                    {
                        codes: ['M_TenantOrganization','M_AddTenantOrganization','M_EditTenantOrganization','M_ViewTenantCorTable'],
                        name: "Tenant Company",
                        permissionType: 0,
                        icon: "",
                        route: "/tenantOrganization",
                        module: "adminManagement/tenantOrganization",
                        sort: 7,
                        children: [
                            {
                                code: "M_AddTenantOrganization",
                                name: "Create Tenant Company",
                                permissionType: 1,
                                icon: "",
                                route: "/addTenantOrganization",
                                module: "adminManagement/addTenantOrganization",
                                sort: 1,
                                children: []
                            },
                            {
                                code: "M_EditTenantOrganization",
                                name: "Edit Tenant Company",
                                permissionType: 1,
                                icon: "",
                                route: "/editTenantOrganization",
                                module: "adminManagement/editTenantOrganization",
                                sort: 2,
                                children: []
                            },
                            {
                                code: "M_ViewTenantCorTable",
                                name: "View Correspondence Table",
                                permissionType: 1,
                                icon: null,
                                route: "/tenantCorrespondence",
                                module: "adminManagement/tenantCorrespondence",
                                sort: 4,
                                children: []
                            },
                        ]
                    },
                    {
                        code: "M_SingleEntryPolicy",
                        name: "Single Entry Policy",
                        permissionType: 0,
                        icon: "",
                        route: "/singleEntry",
                        module: "adminManagement/singleEntryPolicy",
                        sort: 7,
                        children: []
                    },
                    {
                        code: "M_AttendanceSetting",
                        name: "Attendance Setting",
                        permissionType: 0,
                        icon: "",
                        route: "/attendanceManagement",
                        module: "adminManagement/attendanceManagement",
                        sort: 8,
                        children: []
                    },
                    {
                        code: "M_CostCenterManagement",
                        name: "Cost Center Management",
                        permissionType: 0,
                        icon: "",
                        route: "/costCenterManagement",
                        module: "adminManagement/costCenterManagement",
                        sort: 9,
                        children: []
                    }
                ]
            },
            {
                isTabRoute: true,
                codes: ['N_SystemSystemSetting','M_DataRetention','M_ScheduleList','M_PublicHoliday','M_KioskSetting','M_OfficeManagement'],
                name: "System Setting",
                permissionType: 0,
                icon: null,
                route: "/systemSetting",
                module: "systemManagement/systemSetting",
                sort: 2,
                children: [
                    {
                        code: "M_BasicSetting",
                        name: "Basic Setting",
                        permissionType: 0,
                        icon: null,
                        route: "/basicSetting",
                        module: "systemManagement/basicSetting",
                        sort: 0,
                        children: []
                    },
                    {
                        code: "M_DataRetention",
                        name: "Data Retention",
                        permissionType: 0,
                        icon: null,
                        route: "/retention",
                        module: "systemManagement/dataRetention",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_ScheduleList",
                        name: "Schedule List",
                        permissionType: 0,
                        icon: "",
                        route: "/scheduleList",
                        module: "systemManagement/scheduleList",
                        sort: 3,
                        children: []
                    },
                    {
                        code: "M_PublicHoliday",
                        name: "Public Holiday",
                        permissionType: 0,
                        icon: "",
                        route: "/holidaySetting",
                        module: "systemManagement/holidaySetting",
                        sort: 4,
                        children: []
                    },
                    {
                        code: "M_KioskSetting",
                        name: "Kiosk Setting",
                        permissionType: 0,
                        icon: "",
                        route: "/kioskSetting",
                        module: "systemManagement/kioskSetting",
                        sort: 5,
                        children: []
                    },
                    {
                        code: "M_OfficeManagement",
                        name: "Office Management",
                        permissionType: 0,
                        icon: "",
                        route: "/officeManagement",
                        module: "systemManagement/officeManagement/officeManagement",
                        sort: 6,
                        children: []
                    },
                    {  
                        code:'M_IntegrationAccount',
                        name:'Integration Account', 
                        permissionType: 0,
                        icon: "",
                        route: "/integration",
                        module: "systemManagement/integration",
                        sort: 7,
                        children: []
                   },
                ]
            },
            {
                isTabRoute: true,
                codes: ['N_SystemSystemMaintenance','M_ExternalServiceManagement','M_SystemServiceManagement','M_ServerManagement','M_HandheldManagement','M_SystemLog','M_PatchHistory'],
                name: "System Maintenance",
                permissionType: 0,
                icon: null,
                route: "/maintenance",
                module: "maintenanceManagement/maintenance",
                sort: 3,
                children: [
                    {
                        code: "M_ExternalServiceManagement",
                        name: "External Service Management",
                        permissionType: 0,
                        icon: "",
                        route: "/thirdPartyService",
                        module: "maintenanceManagement/thirdPartyService",
                        sort: 1,
                        children: []
                    },
                    {
                        code: "M_SystemServiceManagement",
                        name: "System Service Management",
                        permissionType: 0,
                        icon: "",
                        route: "/systemService",
                        module: "maintenanceManagement/systemService",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_ServerManagement",
                        name: "Server Management",
                        permissionType: 0,
                        icon: "",
                        route: "/serverManagement",
                        module: "maintenanceManagement/serverManagement",
                        sort: 3,
                        children: []
                    },
                    {
                        code: "M_HandheldManagement",
                        name: "Handheld Management",
                        permissionType: 0,
                        icon: "",
                        route: "/handheldManagement",
                        module: "maintenanceManagement/handheldManagement",
                        sort: 2,
                        children: []
                    },
                    {
                        code: "M_SystemLog",
                        name: "System Log",
                        permissionType: 0,
                        icon: null,
                        route: "/systemLog",
                        module: "maintenanceManagement/systemLog",
                        sort: 6,
                        children: []
                    },
                    {
                        code: "M_PatchHistory",
                        name: "Patch History",
                        permissionType: 0,
                        icon: "",
                        route: "/patchHistory",
                        module: "maintenanceManagement/patchHistory/patchHistory",
                        sort: 8,
                        children: []
                    }
                ]
            },
            {
                code: "M_LicenseManagement",
                name: "License Management",
                permissionType: 0,
                icon: null,
                route: "/licenceManagement",
                module: "systemManagement/licenceManagement",
                sort: 4,
                children: []
            }
        ]
    },
    {
        code: "N_ICS",
        name: "ICS",
        permissionType: 0,
        icon: "m_ics",
        route: null,
        module: null,
        sort: 8,
        children:[     
            {
                code: 'N_ICSManagement',
                name: "ICS Management",
                permissionType: 0,
                icon: null,
                route: "/icsManagement",
                module: "icsManagement/icsManagement/icsManagement",
                sort: 0,
                children: [],
            },
            {
                isTabRoute: true,
                codes: ['N_AudioTaskManagement','M_ICSMusicSetting','M_PlayTaskSetting'],
                name: "Audio Task Management",
                permissionType: 0,
                icon: null,
                route: "/audioTaskManagement",
                module: "icsManagement/audioTaskManagement/audioTaskManagement",
                sort: 2,
                children: [
                    {
                        code: "M_ICSMusicSetting",
                        name: "Music",
                        permissionType: 0,
                        icon: null,
                        route: "/icsMusicSetting",
                        module: "icsManagement/audioTaskManagement/musicSetting/musicSetting",
                        sort: 0,
                        children: []
                    },
                    {
                        code: "M_PlayTaskSetting",
                        name: "Play Task",
                        permissionType: 0,
                        icon: null,
                        route: "/icsPlayTask",
                        module: "icsManagement/audioTaskManagement/palyTaskSetting/playTaskSetting",
                        sort: 1,
                        children: []
                    },
                ],
            },
            {
                code: "M_ICSCommsManagement",
                name: "Comms Management",
                permissionType: 0,
                icon: null,
                route: "/commsManagement",
                module: "icsManagement/icsCommsManagement/commsManagement",
                sort: 3,
                children: [],
            },
        ]
    },
];
if(window.g.isLatestHealth){
  menu.push({
    code: "M_HealthMonitoring",
    name: "Health Monitoring",
    permissionType: 0,
    icon: "m_health",
    route: null,
    module: null,
    // sort: 6,
    sort: 7,
    children:[
        {
            isTabRoute: true,
            code: "M_Overview",
            name: "Overview",
            permissionType: 0,
            icon: null,
            route: "/overview",
            module: "healthMonitoring/overview/overview",
            sort: 0,
        },
        {
            isTabRoute: true,
            code: "M_Dashboard",
            name: "Dashboard",
            permissionType: 0,
            icon: null,
            route: "/Dashboard",
            module: "healthMonitoring/dashboard/dashboard",
            sort: 1,
        },
        {
            isTabRoute: true,
            //codes: ['M_Infrastructure','M_Health_Server','M_Health_Service','M_Health_Device','M_Health_It_Device','M_Health_Custom_Health'],
            code:'M_Infrastructure',
            name: "Infrastructure",
            permissionType: 0,
            icon: null,
            route: "/healthList",
            module: "healthMonitoring/healthMonitoring",
            sort: 2,
            children:[
                {
                    isTabRoute: true,
                    code: "M_Health_Server",
                    name: "Server",
                    permissionType: 0,
                    icon: null,
                    route: "/healthServer",
                    module: "healthMonitoring/healthServerLatest/healthServerLatest",
                    sort: 1,
                },
                {
                    isTabRoute: true,
                    code: "M_Health_Service",
                    name: "Service",
                    permissionType: 0,
                    icon: null,
                    route: "/healthService",
                    module: "healthMonitoring/healthServiceLatest/healthServiceLatest",
                    sort: 2,
                },
                {
                    isTabRoute: true,
                    code: "M_Health_Device",
                    name: "Device",
                    permissionType: 0,
                    icon: null,
                    route: "/healthDevice",
                    module: "healthMonitoring/healthDeviceLatest/healthDeviceLatest",
                    sort: 3,
                },
                {
                    isTabRoute: true,
                    code: "M_Health_It_Device",
                    name: "IT Infrastructure",
                    permissionType: 0,
                    icon: null,
                    route: "/healthItDevice",
                    module: "healthMonitoring/healthItDeviceLatest/healthItDeviceLatest",
                    sort: 4,
                },
                {
                    isTabRoute: true,
                    code: "M_Health_Custom_Health",
                    name: "Custom Health",
                    permissionType: 0,
                    icon: null,
                    route: "/customHealth",
                    module: "healthMonitoring/healthCustomLatest/healthCustomLatest",
                    sort: 5,
                },
               
            ]
        },
        {
            isTabRoute: true,
            code: "M_IsolateManagement",
            name: "Isolate Management",
            permissionType: 0,
            icon: null,
            route: "/isolateManagement",
            module: "healthMonitoring/isolateManagement/isolateManagement",
            sort: 3,
        },
        
        {
            code: "M_Health_Server_Analyze",
            name: "Server Analyze",
            permissionType: 1,
            icon: null,
            route: "/ServerAnalyze",
            module: "healthMonitoring/ServerAnalyze/ServerAnalyze",
            sort: 6,
        },
        {
            code: "M_Health_Custom_management",
            name: "Custom Health Management",
            permissionType: 1,
            icon: null,
            route: "/customHealthManagement",
            module: "healthMonitoring/healthCustomManagement/healthCustomManagement",
            sort: 6,
        },
        {
            code: "M_tile_management",
            name: "Tile Management",
            permissionType: 1,
            icon: null,
            route: "/tileManagement",
            module: "healthMonitoring/tileManagement/tileManagement",
            sort: 6,
        },
        {
            code: "M_tile_Map_Management",
            name: "Tile Map Management",
            permissionType: 1,
            icon: null,
            route: "/tileMapManagement",
            module: "healthMonitoring/tileMapManagement/tileMapManagement",
            sort: 6,
        },
        {
            code: "M_Add_tile_Map",
            name: "Create Tile Map Management",
            permissionType: 1,
            icon: null,
            route: "/addTileMapManagement",
            module: "healthMonitoring/addTileMap/addTileMap",
            sort: 6,
        }
    ]
},)
}else{
    menu.forEach((item)=>{
        if(item.name == "System"){
            item.children.forEach(item2 => {
              if(item2.name == 'System Maintenance'){
                item2.children.push({
                    code: "M_ExternalSystemManagement",
                    name: "External System Management",
                    permissionType: 0,
                    icon: "",
                    route: "/externalSystem",
                    module: "maintenanceManagement/externalSystem",
                    sort: 4,
                    children: []
                })
                item2.children.push( {
                    code: "M_HealthMonitoring",
                    name: "Health Monitoring",
                    permissionType: 0,
                    icon: null,
                    route: "/healthMonitoring",
                    module: "maintenanceManagement/healthMonitoring",
                    sort: 5,
                    children: []
                },)
              }
            })
            
           
        }
    })
}
menu.sort((a,b) => a.sort - b.sort)
export default menu


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/menu.js
// module id = G47j
// module chunks = 15